import { render, staticRenderFns } from "./saudeProfissionais.vue?vue&type=template&id=6662ecdb&scoped=true&"
import script from "./saudeProfissionais.vue?vue&type=script&lang=js&"
export * from "./saudeProfissionais.vue?vue&type=script&lang=js&"
import style0 from "./saudeProfissionais.vue?vue&type=style&index=0&id=6662ecdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6662ecdb",
  null
  
)

export default component.exports